import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  errorCode: null,
  data: {},
};

const instructorSlice = createSlice({
  name: "instructor",
  initialState,
  reducers: {
    setInstructorData(state, action) {
      state.status = action.payload.status;
      state.errorCode = action.payload.errorCode;
      state.data = action.payload.data;
    },
    clearInstructorData(state) {
      state.status = null;
      state.errorCode = null;
      state.data = null;
    },
  },
});

export const { setInstructorData, clearInstructorData } =
  instructorSlice.actions;

export const selectInstructorData = (state) => state.instructor.data;

export default instructorSlice.reducer;
